import { useEffect, useState } from 'react'

export function usePreviewExpiryCountdown(expiresAt: string, enabled: boolean): string {
    const [label, setLabel] = useState('')

    useEffect(() => {
        if (!enabled) {
            setLabel('')
            return undefined
        }
        const tick = () => {
            const parsed = new Date(expiresAt).getTime()
            if (Number.isNaN(parsed)) {
                setLabel('')
                return
            }
            const ms = parsed - Date.now()
            if (ms <= 0) {
                setLabel('Expired')
                return
            }
            const totalSec = Math.floor(ms / 1000)
            const minutes = Math.floor(totalSec / 60)
            const seconds = totalSec % 60
            setLabel(`${minutes}:${seconds.toString().padStart(2, '0')}`)
        }
        tick()
        const id = window.setInterval(tick, 1000)
        return () => window.clearInterval(id)
    }, [expiresAt, enabled])

    return label
}
